import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { shapes } from '@unite-us/client-utils';
import { Spinner } from 'common/spinners';
import { DynamicTable } from 'common/tables';
import firstLine from 'common/utils/firstLine';
import CaseRowIcon from 'src/components/Dashboard/components/Cases/CaseRowIcon';
import _ from 'lodash';
import { showFacesheetCasesTableDescription } from 'common/utils/FeatureFlags/flags';
import {
  clientNameColumn,
  networkColumn,
  serviceTypeColumn,
} from '../../utils/columnConfigs/baseColumns';
import FilterBar from '../FilterBar';

export function ClosedOONCasesIndex(props) {
  const {
    paging,
    data,
    onNextClick,
    onPrevClick,
    isFetching,
    onCellClick,
    initialSort,
    isCC,
    isSuperNetwork,
    filters,
    onFiltersChange,
    isCaseMgmtProvider,
    fetchGroupsUsers,
    showDescription,
    sortConfig,
    setSort,
  } = props;

  const onSortColumn = (column, sortDirection) => {
    if (sortConfig) {
      sortConfig(column, sortDirection);
    }
  };

  const getColumns = () => {
    const descColumn = {
      label: 'Description',
      formatData: (item) => firstLine(item.description),
      className: 'truncate',
    };
    const baseColumns = [
      {
        label: 'Primary Worker',
        sortColumn: 'primary_worker.full_name',
      },
      ...(isCC ? [networkColumn(isSuperNetwork, 'network.name')] : []),
      clientNameColumn(setSort, onSortColumn),
      ...(showDescription ? [descColumn] : []),
      serviceTypeColumn(),
      {
        label: 'Date Opened',
        sortColumn: 'opened_date',
        sortBy: setSort?.sidx,
        sortDirection: setSort?.sord,
        setSort: ({ sortBy, sortDirection }) => onSortColumn(sortBy, sortDirection),
        type: 'date',
      },
      {
        label: 'Last Updated',
        sortColumn: 'updated_at',
        sortBy: setSort?.sidx,
        sortDirection: setSort?.sord,
        setSort: ({ sortBy, sortDirection }) => onSortColumn(sortBy, sortDirection),
        type: 'date',
      },
    ];
    return _.compact(baseColumns);
  };

  return (
    <div>
      <FilterBar
        filters={filters}
        onFiltersChange={onFiltersChange}
        paging={paging}
        onNextClick={onNextClick}
        onPrevClick={onPrevClick}
        isFetching={isFetching && !_.isEmpty(data)}
        asyncSearch={fetchGroupsUsers}
      />
      <div className="dashboard-inner-content">
        {
          (isFetching && _.isEmpty(data)) ?
            <Spinner /> : (
              <DynamicTable
                caption="Closed out-of-network cases"
                id="closed-oon-cases-table"
                dataSet={data}
                onCellClick={onCellClick}
                initialSort={initialSort}
                columnLabels={getColumns()}
                rowIcon={(serviceCase) => (
                  <CaseRowIcon
                    isCC={isCC}
                    isCaseMgmtProvider={isCaseMgmtProvider}
                    serviceCase={serviceCase}
                  />
                )}
                emptyMessage="There are no closed cases."
              />
            )
        }
      </div>
    </div>
  );
}

ClosedOONCasesIndex.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
  paging: shapes.paging,
  onNextClick: PropTypes.func.isRequired,
  onPrevClick: PropTypes.func.isRequired,
  onCellClick: PropTypes.func.isRequired,
  initialSort: PropTypes.object,
  isCC: PropTypes.bool.isRequired,
  isSuperNetwork: PropTypes.bool,
  filters: PropTypes.array,
  onFiltersChange: PropTypes.func,
  isCaseMgmtProvider: PropTypes.bool,
  fetchGroupsUsers: PropTypes.func.isRequired,
  showDescription: PropTypes.bool,
  sortConfig: PropTypes.func,
  setSort: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    showDescription: showFacesheetCasesTableDescription(state),
  };
}

export default connect(mapStateToProps)(ClosedOONCasesIndex);
